const itemlistSchema = (description, itemListElement = []) => {
  if (itemListElement.length < 1) return;
  return {
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    description,
    itemListOrder: 'http://schema.org/ItemListOrderAscending',
    itemListElement
  };
};

export default itemlistSchema;
